<template>
  <div class="print-footer">
    <div class="footer-content">
      <div class="footer-item">
        <span class="label">{{ Lang.get('messages.print_date') || 'تاريخ الطباعة' }}:</span>
        <span class="value">{{ currentDateTime }}</span>
      </div>
      <div class="footer-item">
        <span class="label">{{ Lang.get('messages.printed_by') || 'طبع بواسطة' }}:</span>
        <span class="value">{{ userName }}</span>
      </div>
      <div class="footer-item page-numbering">
        {{ Lang.get('messages.page') || 'صفحة' }} <span class="pageNumber"></span> {{ Lang.get('messages.of') || 'من' }} <span class="totalPages"></span>
      </div>
    </div>
    <div class="footer-bottom-line"></div>
    <div class="system-tag">
      {{ systemName }} - {{ Lang.get('messages.automated_report') || 'تقرير تلقائي من النظام' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintFooter',
  data() {
    return {
      currentDateTime: new Date().toLocaleString(),
    }
  },
  computed: {
    userName() {
      return this.$store.getters['auth/user'] ? this.$store.getters['auth/user'].name : 'Admin';
    },
    systemName() {
      return this.$store.getters['settings/systemName'] || 'Schoolna';
    }
  }
}
</script>

<style scoped>
.print-footer {
  width: 100%;
  margin-top: 30px;
  border-top: 2px solid #1d5166;
  padding-top: 15px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #4a5568;
  margin-bottom: 10px;
}

.footer-item {
  display: flex;
  gap: 5px;
}

.label {
  font-weight: bold;
}

.footer-bottom-line {
  height: 1px;
  background: #e2e8f0;
  margin: 10px 0;
}

.system-tag {
  text-align: center;
  font-size: 10px;
  color: #718096;
  font-style: italic;
}

@media screen {
  .print-footer {
    display: none; /* Only show in print or when explicitly needed */
  }
}

@media print {
  .print-footer {
    display: block !important;
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
</style>
